import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React, { useEffect, useState } from 'react';
import { selectPlacementLandsGtgDetails } from '../../../../../../../store/redux-store/placement-details/selectors';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
interface NameTypes {
  first: string | null;
  last: string | null;
}
const useStyles = makeStyles()({
  container: {
    padding: '12px 0px 0px 7px',
  },
  titleContainer: {},
  lastUpdatedTextContainer: {
    color: '#797979',
    paddingRight: '6px',
    fontSize: '14px',
  },
  lastUpdatedTextContainerAlignment: {
    paddingLeft: '4px !important',
    marginLeft: '-6px',
  },
});
const LandsGtgLastUpdated = () => {
  const { t } = useTranslation();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const [lastUpdated, setLastUpdated] = useState<string | null>();
  const [name, setName] = useState<NameTypes | null>();
  const { classes } = useStyles();
  useEffect(() => {
    setName(selectLandsGtgDetails?.lastUpdatedByName);
    setLastUpdated(moment(selectLandsGtgDetails?.lastUpdated).format('yyyy-MM-DD hh:mm:ss A'));
    // eslint-disable-next-line
  }, [selectLandsGtgDetails]);

  return (
    <>
      <LayoutGrid className={classes.container} alignItems="center">
        <LayoutGridItem className={classes.titleContainer}>
          {`${t(
            'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsGtgLastUpdated.landsGoodToGo',
          )} `}
          <span className={classes.lastUpdatedTextContainer}>{`\u00A0|\u00A0 ${t(
            'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.landsGtgLastUpdated.lastUpdatedOn',
          )}`}</span>
        </LayoutGridItem>
        {/* display only if values are not null */}
        {name === null || lastUpdated === null ? (
          '--'
        ) : (
          <LayoutGridItem
            className={`${classes.lastUpdatedTextContainer} ${classes.lastUpdatedTextContainerAlignment}`}
          >{`${lastUpdated} by  ${name?.first} ${name?.last}`}</LayoutGridItem>
        )}
      </LayoutGrid>
    </>
  );
};
export default LandsGtgLastUpdated;
